const ko = {
  nav: {
    home: "홈",
    about: "회사 소개",
    destinations: "목적지",
    tours: "투어 및 패키지",
    gallery: "갤러리",
    testimonials: "고객 후기",
    blog: "블로그",
    contact: "문의하기",
    experiences: "체험",
    vip: "VIP 비즈니스",
    vipFull: "VIP 비즈니스 여행",
    worldcup: "2030 월드컵",
    jewishHeritage: "코셔 여행",
    menu: "메뉴",
    chatWhatsApp: "WhatsApp으로 채팅하기"
  },
  hero: {
    welcome: "모로코에 오신 것을 환영합니다.",
    welcomeHome: "환영합니다.",
    subtitle: "프라이빗 럭셔리 투어, 진정한 경험,",
    subtitleLine2: "그리고 모로코 전역의 완전한 개인 맞춤형 서비스 —",
    subtitleGold: "CEO가 직접 관리합니다.",
    whatsappBtn: "지금 WhatsApp으로 Ilan (CEO)과 채팅하기",
    badgeFast: "빠른 답변",
    badgePersonal: "개인 맞춤 서비스",
    badge247: "24/7 이용 가능",
    limitedAvail: "예약 마감 임박",
    personalizedOnly: "맞춤형 여행 전용"
  },
  strip: {
    privateTours: "프라이빗 투어",
    localExperts: "현지 전문가",
    bestHotels: "최고의 호텔",
    luxuryTransport: "럭셔리 교통편",
    satisfaction: "100% 만족 보장"
  },
  cta: {
    whatsapp: "지금 WhatsApp으로 Ilan (CEO)과 채팅하기",
    whatsappFloating: "WhatsApp 채팅",
    whatsappInquiry: "안녕하세요, 프리미엄 모로코 여행 경험에 관심이 있습니다."
  },
  home: {
    vipBannerTitle: "VIP 모로코 여행 경험",
    vipBannerText: "안목 있는 여행자를 위한 전용 혜택, 전용 운전기사 및 럭셔리 숙박 시설.",
    vipBannerBtn: "VIP 서비스 알아보기",
    wcBadge: "🇲🇦 모로코 2030 월드컵",
    wcTitle: "모로코 2030",
    wcText: "축구, 모로코 문화, VIP 환대 및 럭셔리 경험이 결합된 독점 월드컵 여행 패키지.",
    wcBtn: "패키지 보기",
    galleryTitle: "갤러리",
    gallerySubtitle: "미래의 모로코 여행을 엿보세요",
    exploreDestination: "목적지 탐색",
    featuredToursTitle: "추천 투어 및 패키지",
    featuredToursSubtitle: "완벽한 모로코 여행을 위해 세심하게 큐레이션된 경험",
    viewAllTours: "모든 투어 보기",
    culinaryTitle: "우리의 음식 - 세계 최고",
    culinarySubtitle: "모로코 요리의 우수성을 경험해보세요 🍲",
    culinaryBtn: "미식 경험 알아보기",
    culinaryIntro: "Morocco Loves You에서 식사는 단순한 식사가 아닙니다. 그것은 모로코 문화의 심장부로 떠나는 여행입니다. 우리는 전통적인 가정식부터 고급 모로코 미식까지, 사랑과 가장 신선한 현지 식재료로 정성껏 준비된 진정한 엄선된 미식 경험을 제공합니다.",
    videoTitle: "추천",
    unityQuote: "Morocco Loves You는 모든 문화, 모든 신념, 모든 사람들을 환영합니다.",
    unityAlt: "Morocco Loves You 화합 배너",
    testimonialsTitle: "VIP 고객 후기",
    testimonialsSubtitle: "전 세계 여행자들의 생생한 리뷰",
    readMoreReviews: "리뷰 더 보기",
    viewAllTransport: "모든 교통 수단 보기",
    transportTitle: "VIP 교통 서비스 및 기사",
    transportSubtitle: "모로코 전역에서의 럭셔리함, 편안함, 안전함 🌍",
    transportIntro: "Morocco Loves You에서 교통은 단순한 이동 수단이 아닙니다. 그것은 경험의 일부입니다. 우리는 전문 기사, 따뜻한 환대, 그리고 첫 순간부터 VIP 서비스를 제공하며, 모로코 전역에 깨끗하고 편안한 최신 에어컨 시설을 갖춘 차량을 제공합니다."
  },
  tours: {
    pageTitle: "투어 및 패키지",
    pageSubtitle: "세심하게 엄선된 모로코 투어 패키지 중 선택하세요",
    sectionTitle: "투어 패키지",
    sectionIntro: "사막 모험부터 해변 휴양지까지, 모든 여행자를 위한 완벽한 패키지를 제공합니다",
    howToBook: "예약 방법",
    step1Title: "투어 선택",
    step1Text: "패키지를 살펴보고 가장 적합한 것을 선택하세요",
    step2Title: "지금 예약하기 클릭",
    step2Text: "선택한 투어의 '지금 예약하기' 버튼을 클릭하세요",
    step3Title: "세부 정보 입력",
    step3Text: "여행 날짜 및 개인 정보를 제공해주세요",
    step4Title: "예약 확인",
    step4Text: "이메일로 확인 및 일정 세부 정보를 받으세요",
    customTitle: "맞춤형 패키지가 필요하신가요?",
    customText: "문의하여 개인 맞춤형 모로코 투어 일정을 만들어보세요",
    customBtn: "문의하기",
    days: "일",
    highlights: "하이라이트:",
    bookNow: "지금 예약하기",
    highlightsLabel: "하이라이트:",
    viewFullDetails: "전체 상세 보기",
    premiumMoroccoPackages: "프리미엄 모로코 패키지",
    premiumMoroccoPackagesDesc: "품격 있는 고객을 위해 세심하게 엄선한 특별한 경험입니다.",
    pkg1: {
      title: "유럽/모로코 럭셔리 주말 여행",
      duration: "3박 / 4일",
      price: "€790",
      hl1: "직항 왕복 항공편 포함(런던/유럽)",
      hl2: "4-5성급 럭셔리 호텔",
      hl3: "전통 모로코 하맘",
      hl4: "요리 및 예술 워크숍",
      hl5: "모로코 라이브 공연"
    },
    pkg2: {
      title: "모로코 럭셔리 디스커버리 투어",
      duration: "6박 / 7일",
      price: "€1490",
      hl1: "패키지 A",
      hl2: "아틀라스 여정",
      hl3: "마라케시 - 에사우이라 - 메르주가 - 와르자자트 - 마라케시",
      hl4: "큰 서프라이즈 ❤️",
      hl5: "패키지 B"
    },
    pkg3: {
      title: "모로코 그랜드 익스피리언스",
      duration: "10박 / 11일",
      price: "€1990",
      hl1: "프리미엄 지상 서비스 전체",
      hl2: "카사블랑카, 마라케시 및 페스",
      hl3: "아가디르와 사하라 사막 서프라이즈",
      hl4: "와르자자트와 셰프샤우엔 방문",
      hl5: "특별 라이브 음악 및 공연"
    },
    pkg4: {
      title: "럭셔리 모로코 익스피리언스",
      duration: "16박 / 17일",
      price: "올 인클루시브",
      hl1: "카사블랑카 • 라바트 • 페스 • 탕헤르 • 셰프샤우엔",
      hl2: "이프란 • 메르주가 사하라 사막",
      hl3: "에사우이라 • 우리카와 아틀라스 산맥 • 마라케시",
      hl4: "낙타 및 지프 투어가 포함된 럭셔리 사막 캠프 2박",
      hl5: "마법 같은 일출과 일몰 • 별빛 아래에서의 숙박"
    }
  },
  destinations: {
    pageTitle: "모로코 목적지 탐험",
    pageSubtitle: "아름다운 모로코 전역의 놀라운 장소들을 발견하세요",
    sectionTitle: "모든 목적지",
    sectionIntro: "모로코는 다양한 풍경과 풍부한 문화 유산을 가진 나라입니다. 저희가 엄선한 목적지들을 탐험해보세요:",
    exploreNow: "지금 탐험하기",
    ctaTitle: "여행을 계획할 준비가 되셨나요?",
    ctaText: "저희가 엄선한 투어 및 패키지를 살펴보고 완벽한 모로코 경험을 찾아보세요",
    ctaBtn: "투어 및 패키지 보기"
  },
  experiences: {
    pageTitle: "모로코 요리의 우수성",
    pageSubtitle: "세계 최고의 요리를 만나보세요",
    bookViaWhatsApp: "WhatsApp으로 예약하기"
  },
  vip: {
    pageTitle: "VIP 및 비즈니스 여행",
    pageSubtitle: "CEO, 투자자 및 안목 있는 여행자를 위한 독점 서비스",
    introTitle: "모로코에서의 완벽한 서비스",
    introText: "MoroccoLovesYou는 비즈니스 여행자, 기업 대표단 및 VIP 고객을 위해 비할 데 없는 수준의 서비스를 제공합니다. 고객님의 시간이 소중하다는 것을 잘 알고 있습니다.",
    ctaTitle: "CEO에게 직접 문의",
    ctaText: "긴급한 문의 및 고도로 전문화된 요청의 경우 창립자 겸 CEO인 Ilan Hatchuel과 직접 상담하십시오.",
    ctaBtn: "Ilan에게 지금 문의하기",
    luxuryTransport: "럭셔리 교통편",
    luxuryTransportDesc: "고급 차량(메르세데스 S클래스, V클래스)을 갖춘 VIP 공항 교통편 및 24시간 개인 운전 기사.",
    premiumAccom: "프리미엄 숙박",
    premiumAccomDesc: "임원에게 적합한 5성급 호텔, 럭셔리 리아드 또는 프라이빗 빌라 단독 예약.",
    businessConcierge: "비즈니스 컨시어지",
    businessConciergeDesc: "회의 지원, 프라이빗 다이닝 예약 및 기업 워크숍을 위한 특별 일정.",
    securityPrivacy: "보안 및 프라이버시",
    securityPrivacyDesc: "유명 인사를 위한 신중한 서비스, 안전한 환경 및 철저한 기밀 유지.",
    support247: "24/7 지원",
    support247Desc: "CEO와의 직접적인 연락 및 고객님의 체류 기간 내내 대기하는 전담 팀.",
    customItineraries: "맞춤형 일정",
    customItinerariesDesc: "비즈니스 일정과 프리미엄 모로코 문화 체험을 완벽하게 균형 맞춘 맞춤형 여행 계획."
  },
  worldcup: {
    pageTitle: "모로코 2030 월드컵",
    pageSubtitle: "최대 규모의 축구 이벤트를 위한 독점 VIP 패키지 및 여행",
    limitedBadge: "예약 마감 임박",
    introTitle: "최고의 축구 여행",
    introText: "2030년 모로코는 FIFA 월드컵을 공동 개최합니다. 최고 수준의 편안함과 특별한 혜택을 원하는 팬들을 위해 설계된 올인원 럭셔리 여행 패키지를 독점 제공하게 되어 자랑스럽습니다.",
    packagesTitle: "프리미엄 월드컵 패키지",
    silverTitle: "실버 패키지",
    silverSub: "에센셜 경험",
    goldTitle: "골드 패키지",
    goldSub: "럭셔리 경험",
    mostPopular: "가장 인기 있는 상품",
    diamondTitle: "다이아몬드 VIP",
    diamondSub: "최고의 경험",
    inquireWhatsApp: "WhatsApp으로 문의",
    ctaTitle: "가격이 인상되기 전에 예약하세요",
    ctaText: "국제적인 수요가 매우 높기 때문에 VIP 패키지를 일찍 예약하는 것을 강력히 권장합니다.",
    ctaBtn: "오늘 문의하기",
    silverF1: "프리미엄 리아드 / 4성급 호텔 숙박",
    silverF2: "사전 계획된 경기 당일 이동수단",
    silverF3: "개최 도시 가이드 투어",
    silverF4: "24/7 전담 지원 라인",
    goldF1: "5성급 호텔 / 럭셔리 빌라 숙박",
    goldF2: "개인 공항 및 경기장 이동 수단",
    goldF3: "VIP 사막 캠프 휴양 (2일)",
    goldF4: "2개 국어 구사 개인 컨시어지",
    diamondF1: "프레지덴셜 스위트룸 / 프라이빗 궁전",
    diamondF2: "24/7 개인 운전 기사 및 보안 요원",
    diamondF3: "VIP 행사 및 파티 독점 참여",
    diamondF4: "CEO 직접 응대 및 VVIP 컨시어지"
  },
  gallery: {
    pageTitle: "갤러리",
    pageSubtitle: "잊을 수 없는 모로코 여행의 시각적 추억",
    picturesTitle: "사진으로 보는 모로코",
    picturesIntro: "모로코의 숨막히는 사진 컬렉션을 살펴보세요",
    videosTitle: "영상으로 보는 모로코",
    videosIntro: "선별된 비디오 컬렉션을 통해 모로코를 경험해보세요"
  },
  testimonials: {
    pageTitle: "고객 후기",
    pageSubtitle: "모로코 여행 경험에 대한 저희 고객들의 이야기를 읽어보세요",
    sectionTitle: "행복한 여행자들",
    sectionIntro: "수천 명의 만족스러운 고객들이 저희와 함께 모로코의 마법을 경험했습니다",
    verifiedGuest: "인증된 고객",
    ratingsTitle: "평점",
    avgRating: "평균 평점",
    verifiedReviews: "인증된 리뷰",
    fromReal: "실제 여행자의 리뷰",
    custSatisfaction: "고객 만족도",
    wouldRecommend: "추천 의향",
    shareTitle: "경험을 공유해주세요",
    shareText: "저희와 함께한 여행이 즐거우셨나요? 여러분의 이야기를 듣고 싶습니다!",
    shareBtn: "후기 작성하기"
  },
  blog: {
    pageTitle: "여행 블로그",
    pageSubtitle: "모로코 여행을 위한 이야기, 팁, 가이드",
    sectionTitle: "최신 여행 기사",
    sectionIntro: "모로코 여행, 현지 문화 및 내부자 팁에 대한 최신 기사를 읽어보세요",
    readMore: "더 보기 →",
    by: "작성자",
    newsletterTitle: "뉴스레터 구독하기",
    newsletterText: "최신 여행 팁과 독점 혜택을 이메일로 받아보세요",
    newsletterPlaceholder: "이메일을 입력하세요",
    subscribe: "구독하기"
  },
  contact: {
    pageTitle: "문의하기",
    pageSubtitle: "VIP 모로코 여행을 계획하려면 저희 팀에 문의하세요",
    getInTouch: "연락하기",
    getInTouchText: "궁금한 점이 있으시면 언제든지 도와드리겠습니다.",
    address: "주소",
    phone: "전화",
    email: "이메일",
    businessHours: "영업 시간",
    businessHoursText: "월요일 - 금요일: 오전 9:00 - 오후 6:00\n토요일: 오전 10:00 - 오후 4:00\n일요일: 휴무",
    followUs: "팔로우하기",
    formTitle: "메시지 보내기",
    successMessage: "✓ 감사합니다! 곧 연락드리겠습니다.",
    fullName: "성함",
    emailAddress: "이메일 주소",
    phoneNumber: "전화번호",
    subject: "제목",
    selectSubject: "제목을 선택하세요",
    tourInquiry: "투어 문의",
    bookingQuestion: "예약 관련 질문",
    customPackage: "맞춤형 패키지",
    feedback: "피드백",
    other: "기타",
    message: "메시지",
    sendMessage: "메시지 보내기",
    mapTitle: "지도에서 찾기",
    faqTitle: "자주 묻는 질문",
    faq1Q: "모로코를 방문하기 가장 좋은 시기는 언제인가요?",
    faq1A: "봄(4~5월)과 가을(9~10월)이 가장 좋습니다.",
    faq2Q: "모로코 방문 시 비자가 필요한가요?",
    faq2A: "비자 요구 사항은 국적에 따라 다릅니다. 많은 국가에서 최대 90일까지 무비자 입국이 가능합니다.",
    faq3Q: "모로코의 통화는 무엇인가요?",
    faq3A: "모로코 디르함(MAD)이 공식 통화입니다.",
    faq4Q: "모로코에서는 어떤 언어를 사용하나요?",
    faq4A: "아랍어와 베르베르어가 공식 언어입니다. 프랑스어도 널리 사용됩니다.",
    faq5Q: "모로코는 관광객에게 안전한가요?",
    faq5A: "네, 전반적으로 안전합니다. 가이드가 안전한 여행을 보장합니다.",
    faq6Q: "투어 패키지를 맞춤 설정할 수 있나요?",
    faq6A: "물론입니다! 맞춤형 패키지를 제공해드립니다."
  },
  about: {
    pageTitle: "MoroccoLovesYou 소개",
    pageSubtitle: "모로코의 마법을 발견하는 든든한 파트너",
    storyTitle: "우리의 이야기",
    storyP1: "MoroccoLovesYou는 여행자들이 모로코의 진정한 아름다움, 문화 및 환대를 경험할 수 있도록 돕겠다는 사명을 바탕으로 설립되었습니다.",
    storyP2: "설립자인 Fatima Hassan은 모로코와 사랑에 빠졌고, 이 열정을 전 세계와 공유하고 싶었습니다.",
    missionTitle: "🎯 우리의 사명",
    missionText: "모로코의 풍부한 문화 유산을 선보이는 뛰어난 여행 경험을 제공하는 것.",
    visionTitle: "🌟 우리의 비전",
    visionText: "진정성과 신뢰성으로 알려진 모로코 최고의 관광 회사가 되는 것.",
    whyTitle: "왜 MoroccoLovesYou를 선택해야 할까요?",
    expertTitle: "전문 지식",
    expertText: "우리 팀은 모로코에 대한 폭넓은 지식을 보유하고 있습니다.",
    localTitle: "현지 네트워크",
    localText: "검증된 현지 가이드와 협력합니다.",
    valueTitle: "최고의 가치",
    valueText: "품질을 타협하지 않는 경쟁력 있는 가격.",
    safetyTitle: "안전 및 지원",
    safetyText: "24/7 고객 지원 및 종합 여행 보험 포함.",
    sustainTitle: "지속 가능한 관광",
    sustainText: "지역 사회를 지원하고 책임감 있는 관광을 실천합니다.",
    bookingTitle: "쉬운 예약",
    bookingText: "유연한 결제 옵션을 갖춘 간편한 온라인 예약 절차.",
    teamTitle: "우리 팀",
    teamSubtitle: "MoroccoLovesYou의 열정적인 사람들을 만나보세요",
    happyTravelers: "행복한 여행자",
    yearsExp: "년 경력",
    destinationsCount: "목적지",
    satisfactionRate: "만족도"
  },
  footer: {
    description: "저희와 함께 모로코의 마법을 발견하세요. 잊지 못할 추억을 만드세요.",
    quickLinks: "빠른 링크",
    more: "더 보기",
    contactInfo: "연락처 정보",
    copyright: "© 2024 MoroccoLovesYou. 모든 권리 보유."
  },
  starBanner: {
    ceoMessage: "CEO의 메시지",
    watchVideo: "비디오 보기",
    readMessage: "& 메시지 읽기",
    getToKnow: "Ilan을",
    ilanPersonally: "개인적으로 알아보세요"
  },
  tourMini: {
    days: "10 일",
    nights: "/ 9 밤",
    title: "프리미엄 모로코\n투어",
    years: "2026 - 2027",
    departures: "매월 출발",
    allIncluded: "올인클루시브\n풀보드",
    recommendations: "추천",
    recCount: "500명 이상의 행복한 여행자"
  },
  cityDetail: {
    notFound: "도시를 찾을 수 없습니다",
    backHome: "홈으로 돌아가기",
    discoverSubtitle: "아름다움과 문화 발견",
    planTrip: "내 여행 계획하기:",
    galleryOf: "갤러리:",
    bookExperience: "이 경험 예약하기",
    requestItinerary: "전체 일정 요청하기",
    readyToVisit: "방문할 준비가 되셨나요?",
    readyToVisitText: "이 놀라운 목적지로의 완벽한 여행을 계획해 드립니다",
    planMyTrip: "내 여행 계획하기",
    talkExpert: "전문가와 상담하기"
  },
  transportation: {
    pageTitle: "VIP 교통 서비스 및 기사",
    pageSubtitle: "모로코 전역에서의 럭셔리함, 편안함, 안전함",
    introTitle: "저희의 VIP 교통 서비스 및 기사",
    introP1: "Morocco Loves You에서 교통은 단순한 이동 수단이 아닙니다.",
    introP2: "그것은 경험의 일부입니다.",
    introP3: "우리는 전문 기사, 따뜻한 환대, 그리고 첫 순간부터 VIP 서비스를 제공하며, 모로코 전역에 깨끗하고 편안한 최신 에어컨 시설을 갖춘 차량을 제공합니다.",
    introP4: "커플, 가족, 비즈니스 대표단 또는 프라이빗 그룹 등 어떤 형태로 여행하시든, 고객님의 여정이 안전하고 편안하며 잊지 못할 추억이 되도록 최선을 다하겠습니다.",
    servicesTitle: "저희의 교통 서비스에는 다음이 포함됩니다",
    servicesList: [
      "최신 VIP 버스",
      "럭셔리 미니버스",
      "프라이빗 승용차",
      "사막 모험을 위한 4x4 지프",
      "VIP 리무진",
      "공항 픽업 및 드랍 서비스",
      "전문 다국어 기사",
      "쾌적한 에어컨 시설",
      "깨끗하고 잘 관리된 차량",
      "일부 차량 내 냉장고 구비",
      "TV 및 엔터테인먼트 시스템",
      "여행 중 음악 서비스",
      "안전하고 부드러운 주행",
      "모로코 전역 24/7 지원"
    ],
    driversTitle: "저희 기사들을 만나보세요",
    driversText1: "저희 기사들은 Morocco Loves You 가족의 일원입니다.",
    driversText2: "전문적이고 예의 바르며 경험이 풍부하고 항상 미소로 도와드릴 준비가 되어 있습니다.",
    driversText3: "많은 기사들이 여러 언어를 구사하며 모로코에 대해 깊이 알고 있습니다. 덕분에 고객님들은 여행 내내 편안함과 안전함, 그리고 현지와의 연결을 느끼실 수 있습니다.",
    safetyTitle: "안전과 편안함이 최우선입니다",
    safetyText1: "고객님의 편안함과 안전은 저희의 최우선 순위입니다.",
    safetyText2: "모든 차량은 정기적으로 점검 및 청소되며, 모든 여행 전에 세심하게 준비됩니다.",
    safetyText3: "우리는 신뢰할 수 있는 전문 기사 및 고품질 교통 파트너와만 협력합니다.",
    categories: {
      buses: "VIP 버스",
      minibuses: "럭셔리 미니버스",
      cars: "프라이빗 승용차 및 VIP 이동",
      jeeps: "4x4 지프 및 사막 교통",
      meetDrivers: "저희 기사들을 만나보세요",
      videos: "교통 경험 영상"
    },
    videoGalleryTitle: "VIP 경험 영상",
    ctaTitle: "모로코를 편안하게 탐험할 준비가 되셨나요?",
    ctaSubtitle: "창립자 겸 CEO인 Allan과 직접 상담하세요",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "모로코 직통 전화: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "모로코 럭셔리 코셔 투어",
    pageSubtitle: "진정한 유대 문화유산, 100% 코셔 요리, 럭셔리 환대와 특별한 모로코 경험.",
    introTitle: "럭셔리 유대 문화유산 경험",
    introHeading: "진정한 유대 모로코를 발견하세요",
    introText: "모로코 유대 역사의 깊은 뿌리를 우아하고 진정성 있는 프리미엄 여행으로 만나보세요. 전 세계 유대 커뮤니티를 위해 유산, 연결, 편안함에 초점을 둔 완벽한 여정을 제공합니다.",
    introQuote: "“모로코는 관용과 공존의 땅이며, 유대 문화유산이 사랑과 존중으로 보존되는 곳입니다.”",
    experiencesTitle: "코셔 경험 포함 사항",
    experiencesList:     [
          "100% 코셔 음식 및 레스토랑",
          "개인 코셔 셰프 이용 가능",
          "전통 모로코 유대 요리",
          "4성급 및 5성급 럭셔리 호텔",
          "전용 VIP 교통편",
          "다국어 전문 가이드",
          "유대 문화유산 및 회당 투어"
    ],
    expFood: "100% 코셔 음식",
    expRestaurant: "코셔 레스토랑",
    expChef: "개인 코셔 셰프 이용 가능",
    expCuisine: "전통 모로코 유대 요리",
    expHotels: "4성급 및 5성급 럭셔리 호텔",
    expDeluxeHotels: "요청 시 디럭스 호텔 이용 가능",
    expTransport: "전용 VIP 교통편",
    expDrivers: "전문 드라이버",
    expAC: "에어컨 차량",
    expWifi: "일부 차량 WiFi, TV 및 냉장고 제공",
    expGuides: "다국어 전문 가이드",
    expStaff: "히브리어 / 영어 / 프랑스어 / 스페인어 / 러시아어 / 독일어 가능 직원",
    expHeritage: "유대 문화유산 투어",
    expSynagogues: "고대 회당",
    expCemeteries: "유대인 묘지",
    expMuseums: "유대 박물관",
    expSpiritual: "영적 및 문화 체험",
    expDesert: "사하라 사막 체험",
    expHammam: "모로코 하맘 체험",
    expAttractions: "모로코 전역의 특별 명소",
    expAssistance: "24/7 지원",
    packagesTitle: "유연한 코셔 여행 패키지",
    packagesIntro: "고객의 필요, 전통, 여행 스타일, 날짜와 기대에 맞춰 모든 여행을 맞춤 구성합니다.",
    package4_5: "4-5 Days",
    package7_8: "7-8 Days",
    package10_11: "10-11 Days",
    package13_14: "13-14 Days",
    package21: "21일",
    packageTailor: "맞춤형 프라이빗 투어",
    packagesQuote: "“고객의 필요, 전통, 여행 스타일, 날짜와 기대에 맞춰 모든 여행을 맞춤 구성합니다.”",
    safetyTitle: "편안하고 전문적이며 안전한 여행",
    safetyQuote: "“저희 투어는 모로코 전역에서 편안함, 조직력, 서비스 품질, 전문적인 조율에 세심한 주의를 기울여 운영됩니다.”",
    b2bTitle: "B2B 유대 여행 파트너십",
    b2bText: "전 세계 유대 커뮤니티, 회당, 랍비, 코셔 여행 운영사와 협력하여 의미 있는 문화유산 여행을 만듭니다.",
    b2bPartnersList: "협력 대상: 전 세계 유대 커뮤니티, 회당, 랍비, 유대 단체, 코셔 여행 운영사 및 여행사.",
    partnerBtn: "파트너 되기",
    galleryTitle: "코셔 체험 갤러리",
    videosTitle: "추천 영상",
    ctaTitle: "여정을 시작할 준비가 되셨나요?",
    msgAllan: "WhatsApp으로 Allan에게 메시지",
    callMorocco: "모로코 전화: +212 6 63 63 05 79",
    ceoContact: "WhatsApp에서 Allan Hatchuel과 직접 상담",
    exploreBtn: "코셔 투어 보기"
  },
  aria: {
    openMenu: "메뉴 열기",
    closeMenu: "메뉴 닫기",
    whatsappSocial: "WhatsApp",
    kosherTravel: "모로코 코셔 여행",
    logoAlt: "MoroccoLovesYou 로고",
    kingAlt: "모로코 국왕",
    kosherOptionsAlt: "코셔 옵션",
    jewishHeritageArchitecture: "유대 문화유산 건축",
    kosherMoroccanTable: "코셔 모로코 식탁",
    luxuryHospitality: "럭셔리 환대",
    kosherExperience: "코셔 경험",
    jewishHeritageMorocco: "모로코 유대 문화유산",
    kosherFoodMorocco: "모로코 코셔 음식",
    jewishHeritageExperience: "유대 문화유산 경험"
  }
};

export default ko;
